import { receiptNumberGetApi } from "../../api/receipt/receiptNumberGetApi"

export async function receiptNumberGetService(token: string) {
	return await receiptNumberGetApi(token)
}
